'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Personal = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Personal: {
        displayName: 'Personal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/Personal.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 28.12.16.
   */

var Personal = exports.Personal = _wrapComponent('Personal')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        show_preloader: state.preloader.show,
        user: state.auth.user
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Personal, _Component);

    function Personal(props) {
        (0, _classCallCheck3.default)(this, Personal);
        return (0, _possibleConstructorReturn3.default)(this, (Personal.__proto__ || (0, _getPrototypeOf2.default)(Personal)).call(this, props));
    }

    (0, _createClass3.default)(Personal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                user = _props.user;


            var View = _helpers.ThemeHelper.getViewForContainer('Personal', null, { folderName: 'Personal' });

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, { show_menu: !!user }), children);
        }
    }]);
    return Personal;
}(_react2.Component), _class2.propTypes = {
    children: _react2.PropTypes.node,
    show_preloader: _react2.PropTypes.any.isRequired,
    user: _react2.PropTypes.object
}, _temp)) || _class));


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Personal.jsx
// module id = 1833
// module chunks = 0